export type ValidationSeverity = 'error' | 'warning';

export interface ValidationIssue {
  code: string;
  severity: ValidationSeverity;
  message: string;
  node_id?: string;
  node_name?: string;
  /** JSON path to the invalid field (legacy API may use `path`). */
  field_path?: string;
  path?: string;
}

export interface ValidationReport {
  issues: ValidationIssue[];
}

export function issueFieldPath(issue: ValidationIssue): string | undefined {
  return issue.field_path ?? issue.path;
}

export function issueNodeId(issue: ValidationIssue): string | undefined {
  return issue.node_id;
}

export function hasBlockingErrors(report: ValidationReport | null | undefined): boolean {
  return (report?.issues ?? []).some((i) => i.severity === 'error');
}

export function issueCounts(report: ValidationReport | null | undefined): {
  errors: number;
  warnings: number;
} {
  const issues = report?.issues ?? [];
  return {
    errors: issues.filter((i) => i.severity === 'error').length,
    warnings: issues.filter((i) => i.severity === 'warning').length,
  };
}
